import React from 'react';
import { Legals } from '@luckycart/xpn-types';

import { Button, StyledButtonSpan } from '../reward-types/common/common.style';

import legalIcon from './images/legal.icon.svg';
import { ButtonsWrapper, ImgIconsLegal } from './Footer.style';

export type FooterProps = { legals: Legals | undefined };

const Footer: React.FunctionComponent<FooterProps> = (props: FooterProps) => {
  return <ButtonsWrapper>
    <Button as="a" href={props.legals?.buttonUrl} target="_blank">
      <ImgIconsLegal src={legalIcon}/>
      <StyledButtonSpan>{props.legals?.buttonText}</StyledButtonSpan>
    </Button>
  </ButtonsWrapper>;
};

export default Footer;
